module.exports = __webpack_public_path__ + "img/UI_common_framelabelBD_02_c931e5899.png";